import {
  CASE_STATUS_CONFIG,
  CASE_STATUS_LABELS,
  type CaseStatus,
  type ParentCaseTab,
} from '@tutor/types';
export type { ParentCaseTab } from '@tutor/types';

type ParentCaseStatusAppearance = {
  label: string;
  pill: string;
  dot: string;
};

const PARENT_CASE_STATUS_LABEL_OVERRIDES: Partial<Record<CaseStatus, string>> = {
  pending_review: 'Under Review',
  new: 'Matching',
  pending: 'Matching',
};

const PARENT_CASE_STATUS_STYLES: Record<CaseStatus, Omit<ParentCaseStatusAppearance, 'label'>> = {
  pending_review: {
    pill: 'bg-amber-50 text-amber-700 border-amber-200',
    dot: 'bg-amber-400',
  },
  new: {
    pill: 'bg-blue-50 text-blue-700 border-blue-200',
    dot: 'bg-blue-400',
  },
  pending: {
    pill: 'bg-blue-50 text-blue-700 border-blue-200',
    dot: 'bg-blue-400',
  },
  action_needed: {
    pill: 'bg-orange-50 text-orange-700 border-orange-200',
    dot: 'bg-orange-400',
  },
  awaiting_payment: {
    pill: 'bg-violet-50 text-violet-700 border-violet-200',
    dot: 'bg-violet-400',
  },
  rejected: {
    pill: 'bg-red-50 text-red-700 border-red-200',
    dot: 'bg-red-400',
  },
  closed: {
    pill: 'bg-gray-100 text-gray-500 border-gray-200',
    dot: 'bg-gray-300',
  },
};

const PARENT_CASE_TAB_BY_STATUS: Record<Exclude<CaseStatus, 'closed'>, Exclude<ParentCaseTab, 'all'>> = {
  pending_review: 'underReview',
  new: 'matching',
  pending: 'matching',
  action_needed: 'inProgress',
  awaiting_payment: 'inProgress',
  rejected: 'rejected',
};

export function getParentCaseStatusAppearance(status: CaseStatus): ParentCaseStatusAppearance {
  const sharedConfig = CASE_STATUS_CONFIG.find((item) => item.status === status);
  const label = PARENT_CASE_STATUS_LABEL_OVERRIDES[status] ?? CASE_STATUS_LABELS[status];
  const styles = PARENT_CASE_STATUS_STYLES[status];

  return {
    label: sharedConfig?.label ? label : CASE_STATUS_LABELS[status],
    pill: styles.pill,
    dot: styles.dot,
  };
}

export function getParentCaseTabForStatus(status: Exclude<CaseStatus, 'closed'>): Exclude<ParentCaseTab, 'all'> {
  return PARENT_CASE_TAB_BY_STATUS[status];
}
